import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";


const ForgotPasswordLayer = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const imagePath1 = `${process.env.PUBLIC_URL}/assets/images/auth/auth-img.png`
  const imagePath2 = `https://aiwealth.blueastercapital.com/corporate/onboarding/assets/images/aiwealthlogo.png`;

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BaseUrl}/forgot-individual-password`, { email });

      if (response.data.success) {
        toast.success("Password reset email sent successfully.");
        setEmailSent(true);
      } else {
        toast.error(response.data.message || "Failed to send reset email.");
      }
    } catch (error) {
      console.error("Error sending password reset email:", error);
      toast.error("An error occurred while sending the email. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
      <section className="auth forgot-password-page bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src={imagePath1} alt="Auth Illustration" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
               <Link to="/" className="mb-40 max-w-290-px">
                                  <img src={imagePath2} alt="" />
                                </Link>            
            <h4 className="mb-12">Forgot Password</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Enter the email address associated with your account, and we’ll send you a link to reset your password.
            </p>
            {emailSent ? (
              <div className="alert alert-info text-center">
                <p className="text-secondary-light text-sm mb-0">
                  A reset link has been sent to your email. Please check your inbox.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:email" />
                  </span>
                  <input
                    type="email"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                >
                  Continue
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgotPasswordLayer;

